/**
 * @type {ICookieStore}
 */
export default {
    cookieAck: false,

    /**
     * @type {string[]}
     */
    allowedGroups: [],
};
